export default {
  // set selected shipping option
  SHIPPING_OPTIONS_SET_START: 'SHIPPING_OPTIONS_SET_START',
  SHIPPING_OPTIONS_SET_SUCCESS: 'SHIPPING_OPTIONS_SET_SUCCESS',
  SHIPPING_OPTIONS_SET_FAIL: 'SHIPPING_OPTIONS_SET_FAIL',
  // refresh shipping options
  SHIPPING_OPTIONS_REFRESH_START: 'SHIPPING_OPTIONS_REFRESH_START',
  SHIPPING_OPTIONS_REFRESH_SUCCESS: 'SHIPPING_OPTIONS_REFRESH_SUCCESS',
  SHIPPING_OPTIONS_REFRESH_FAIL: 'SHIPPING_OPTIONS_REFRESH_FAIL',
};
